const Integrations = () => import('@/modules/admin/integrations/index.vue');
const Mollie = () => import('@/modules/admin/integrations/settings/Mollie.vue');
const Franchise = () =>
  import('@/modules/admin/integrations/settings/Franchise.vue');
const GoogleCalendar = () =>
  import('@/modules/admin/integrations/settings/google-calendar/index.vue');
const Mailchimp = () =>
  import('@/modules/admin/integrations/settings/Mailchimp.vue');
const Gifty = () =>
  import('@/modules/admin/integrations/settings/gifty/index.vue');
const TreatwellMarketplace = () =>
  import(
    '@/modules/admin/integrations/settings/treatwell-marketplace/index.vue'
  );
const Fiskaly = () =>
  import('@/modules/admin/integrations/settings/fiskaly/index.vue');

const FiskalySignInfo = () =>
  import('@/modules/admin/integrations/settings/fiskaly-sign-info/index.vue');

export default {
  path: 'apps',
  name: 'integrations',
  component: Integrations,
  children: [
    {
      path: 'franchise',
      name: 'integration-franchise',
      component: Franchise,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'mailchimp',
      name: 'integration-mailchimp',
      component: Mailchimp,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'gifty',
      name: 'integration-gifty',
      component: Gifty,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'mollie',
      name: 'integration-mollie',
      component: Mollie,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'google-calendar',
      name: 'integration-google-calendar',
      component: GoogleCalendar,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'treatwell-marketplace-admin',
      name: 'integration-treatwell-marketplace',
      component: TreatwellMarketplace,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'treatwell',
      name: 'integration-treatwell',
      component: {
        template: '<template />',
      },
    },
    {
      path: 'fiscalization',
      name: 'integration-fiscalization',
      component: {
        template: '<template />',
      },
    },
    {
      path: 'fiskaly',
      name: 'integration-fiskaly',
      component: Fiskaly,
      props: {
        parentRouteName: 'integrations',
      },
    },
    {
      path: 'fiskaly-sign-info',
      name: 'integration-fiskaly-sign-info',
      component: FiskalySignInfo,
      props: {
        parentRouteName: 'integrations',
      },
    },
  ],
};
